@if (value !== '') {
    <span>{{value}}</span>
}
@if (!value && value === '') {
    <input [size]="size" [id]="id" type="text" [required]="required" />
}
